import type { UseNavigateResult } from '@tanstack/react-router';
import type { NotificationItineraryView } from './present-notification';

// The Operations Home "Cancelled itineraries" card (`home-cancelled` in
// `@ops/features/filter-cards`): it is the one Operations surface that lists a
// cancelled file's items, so the link selects it and narrows to the trip.
const OPERATIONS_CANCELLED_CARD_ID = 'home-cancelled';

/** Opens the itinerary a notification points at, on the surface it belongs to. */
export const navigateToNotificationItinerary = (
  navigate: UseNavigateResult<string>,
  itineraryId: string,
  view: NotificationItineraryView
) =>
  view === 'operations'
    ? navigate({
        to: '/operations',
        search: {
          tab: 'home',
          opsCard: OPERATIONS_CANCELLED_CARD_ID,
          itineraries: [itineraryId],
        },
      })
    : navigate({ to: '/itineraries/$itineraryId', params: { itineraryId } });
